module.exports = __webpack_public_path__ + "img/3f_happiness.b804d071.svg";